/*
 * Salesforce shows the login page (login.html) in its own frame, separate from the connector frame.
 * Both come from the bridge's origin, so the login page hands the session to the connector over a
 * BroadcastChannel, as Salesforce's sample connector does.
 */
export const LOGIN_CHANNEL = 'broadworks-bridge-login';
export const LOGIN_OK = 'LOGIN_OK';
